import { render, staticRenderFns } from "./DonutChart25.vue?vue&type=template&id=28052428&scoped=true"
import script from "./DonutChart25.vue?vue&type=script&lang=js"
export * from "./DonutChart25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28052428",
  null
  
)

export default component.exports